import React from 'react';
import Heading from '../../../components/controls/Typography/Heading';
import useRecommendation from '../../../utils/useRecommendation';

const ObservationHoursFacility = () => {
  const recommendation = useRecommendation();

  return recommendation.item?.observationHoursDataEval ? (
    <div className="lsn-observation-group lsn-observation-faclity">
      <Heading bold level={3} tabIndex={0} asSpan className="lsn-obs-recommendation-form-header">
        Facility
      </Heading>
      <div className="columns">
        <div className="column col-6 col-md-12 lsn-observation-facility-padding">
          <div className="columns">
            <div className="column col-4 col-md-6 lsn-observationHours-name">
              <b>Facility Name:</b>
            </div>
            <div className="column col-8 col-md-6 lsn-observationHours-name">{recommendation.item?.observationHoursDataEval.facilityName}</div>
          </div>
        </div>
      </div>
      <div className="columns">
        <div className="column col-6 col-md-12 lsn-observation-facility-padding">
          <div className="columns">
            <div className="column col-4 col-md-6 lsn-observationHours-name">
              <b>Street Address:</b>
            </div>
            <div className="column col-8 col-md-6 lsn-observationHours-name">
              {recommendation.item?.observationHoursDataEval.facilityAddress1}
            </div>
          </div>
        </div>
        <div className="column col-6 col-md-12 lsn-observation-facility-padding">
          <div className="columns">
            <div className="column col-4 col-md-6 lsn-observationHours-name">
              <b>Street Address 2:</b>
            </div>
            <div className="column col-8 col-md-6 lsn-observationHours-name">
              {recommendation.item?.observationHoursDataEval.facilityAddress2}
            </div>
          </div>
        </div>
      </div>
      <div className="columns">
        <div className="column col-6 col-md-12 lsn-observation-facility-padding">
          <div className="columns">
            <div className="column col-4 col-md-6 lsn-observationHours-name">
              <b>City:</b>
            </div>
            <div className="column col-8 col-md-6 lsn-observationHours-name">{recommendation.item?.observationHoursDataEval.facilityCity}</div>
          </div>
        </div>
        <div className="column col-6 col-md-12 lsn-observation-facility-padding">
          <div className="columns">
            <div className="column col-4 col-md-6 lsn-observationHours-name">
              <b>State/Province:</b>
            </div>
            <div className="column col-8 col-md-6 lsn-observationHours-name">{recommendation.item?.observationHoursDataEval.facilityState}</div>
          </div>
        </div>
      </div>
      <div className="columns">
        <div className="column col-6 col-md-12 lsn-observation-facility-padding">
          <div className="columns ">
            <div className="column col-4 col-md-6 lsn-observationHours-name">
              <b>Country:</b>
            </div>
            <div className="column col-8 col-md-6 lsn-observationHours-name">
              {recommendation.item?.observationHoursDataEval.facilityCountry}
            </div>
          </div>
        </div>
        <div className="column col-6 col-md-12 lsn-observation-facility-padding">
          <div className="columns">
            <div className="column col-4 col-md-6 lsn-observationHours-name">
              <b>Postal Code:</b>
            </div>
            <div className="column col-8 col-md-6 lsn-observationHours-name">{recommendation.item?.observationHoursDataEval.facilityZip}</div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}


export default ObservationHoursFacility;
